/* Club Perfume Árabe · galería de producto deslizable en móvil */
(() => {
  const mq = window.matchMedia('(max-width: 960px)');
  document.querySelectorAll('.pdp__galeria').forEach(g => {
    const pista = g.querySelector('.pdp__principal');
    const vistas = Array.from(g.querySelectorAll('.pdp__vista'));
    const minis = Array.from(g.querySelectorAll('[data-ver-media]'));
    if (!pista || vistas.length < 2) return;
    const puntos = document.createElement('div');
    puntos.className = 'pdp__puntos';
    puntos.setAttribute('aria-hidden', 'true');
    vistas.forEach((_, i) => { const p = document.createElement('i'); if (i === 0) p.className = 'on'; puntos.appendChild(p); });
    pista.after(puntos);
    const marcar = i => {
      Array.from(puntos.children).forEach((p, k) => p.classList.toggle('on', k === i));
      minis.forEach((b, k) => b.setAttribute('aria-current', String(k === i)));
    };
    let t;
    pista.addEventListener('scroll', () => {
      if (!mq.matches) return;
      clearTimeout(t);
      t = setTimeout(() => {
        const i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
        marcar(Math.max(0, Math.min(i, vistas.length - 1)));
      }, 60);
    }, { passive: true });
    /* Si cambia la variante y su foto pasa a ser la visible, desliza hasta ella */
    new MutationObserver(() => {
      if (!mq.matches) return;
      const i = vistas.findIndex(v => !v.hidden);
      if (i >= 0 && Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth)) !== i) {
        pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' });
        marcar(i);
      }
    }).observe(pista, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  });
})();
